/* global google */
var AddressField, AddressFieldController;

AddressField = require('./address_field');

AddressFieldController = (function() {
  function AddressFieldController(addressInput) {
    this.address = new AddressField(addressInput);
    this.disableEnterFor(addressInput);
    this.address.bump();
  }

  AddressFieldController.prototype.disableEnterFor = function(field) {
    return $(field).keydown(function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        return false;
      }
    });
  };

  return AddressFieldController;
})();

module.exports = AddressFieldController;



// WEBPACK FOOTER //
// ./src/javascripts/legacy/address_field_controller.js